// extracted by mini-css-extract-plugin
export default {"root":"InternalLoanProgramDetailPage_root__77Jjd"};